import createIcon from '../../createIcon';

/**
 * @component @name FilterFrames
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNUgxNkwxMiAxTDggNUg0QzIuOSA1IDIgNS45IDIgN1YyMUMyIDIyLjEgMi45IDIzIDQgMjNIMjBDMjEuMSAyMyAyMiAyMi4xIDIyIDIxVjdDMjIgNS45IDIxLjEgNSAyMCA1Wk0yMCAyMUg0VjdIOC41MkwxMi4wNCAzLjVMMTUuNTIgN0gyMFYyMVpNMTggOUg2VjE5SDE4IiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FilterFrames = createIcon('FilterFrames', [
  [
    'path',
    {
      d: 'M20 5H16L12 1L8 5H4C2.9 5 2 5.9 2 7V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V7C22 5.9 21.1 5 20 5ZM20 21H4V7H8.52L12.04 3.5L15.52 7H20V21ZM18 9H6V19H18',
      key: '1x69hy',
    },
  ],
]);

export default FilterFrames;
